export class ReplaceRequest{
    public fileId:string="";
    public rows:Columns[] = [];
}

export class Columns{
    public a:string|undefined=undefined;
    public b:string|undefined=undefined;
    public c:string|undefined=undefined;
    public d:string|undefined=undefined;
    public e:string|undefined=undefined;
    public f:string|undefined=undefined;
    public g:string|undefined=undefined;
    public h:string|undefined=undefined;
    public i:string|undefined=undefined;
    public j:string|undefined=undefined;
    public k:string|undefined=undefined;
    public l:string|undefined=undefined;
    public m:string|undefined=undefined;
    public n:string|undefined=undefined;
    public o:string|undefined=undefined;
    public p:string|undefined=undefined;
    public q:string|undefined=undefined;
    public r:string|undefined=undefined;
    public s:string|undefined=undefined;
    public t:string|undefined=undefined;
    public u:string|undefined=undefined;
    public v:string|undefined=undefined;
    public w:string|undefined=undefined;
    public x:string|undefined=undefined;
    public y:string|undefined=undefined;
    public z:string|undefined=undefined;
    public aa:string|undefined=undefined;
    public ab:string|undefined=undefined;
    public ac:string|undefined=undefined;
    public ad:string|undefined=undefined;
    public ae:string|undefined=undefined;
    public af:string|undefined=undefined;
    public ag:string|undefined=undefined;
    public ah:string|undefined=undefined;
    public ai:string|undefined=undefined;
    public aj:string|undefined=undefined;
    public ak:string|undefined=undefined;
    public al:string|undefined=undefined;
    public am:string|undefined=undefined;
    public an:string|undefined=undefined;
    public ao:string|undefined=undefined;
    public ap:string|undefined=undefined;
    public aq:string|undefined=undefined;
    public ar:string|undefined=undefined;
    public as:string|undefined=undefined;
    public at:string|undefined=undefined;
    public au:string|undefined=undefined;
    public av:string|undefined=undefined;
    public aw:string|undefined=undefined;
    public ax:string|undefined=undefined;
    public ay:string|undefined=undefined;
    public az:string|undefined=undefined;
    public ba:string|undefined=undefined;
    public bb:string|undefined=undefined;
    public bc:string|undefined=undefined;
    public bd:string|undefined=undefined;
    public be:string|undefined=undefined;
    public bf:string|undefined=undefined;
    public bg:string|undefined=undefined;
    public bh:string|undefined=undefined;
    public bi:string|undefined=undefined;
    public bj:string|undefined=undefined;
    public bk:string|undefined=undefined;
    public bl:string|undefined=undefined;
    public bm:string|undefined=undefined;
    public bn:string|undefined=undefined;
    public bo:string|undefined=undefined;
    public bp:string|undefined=undefined;
    public bq:string|undefined=undefined;
    public br:string|undefined=undefined;
    public bs:string|undefined=undefined;
    public bt:string|undefined=undefined;
    public bu:string|undefined=undefined;
    public bv:string|undefined=undefined;
    public bw:string|undefined=undefined;
    public bx:string|undefined=undefined;
    public by:string|undefined=undefined;
    public bz:string|undefined=undefined;
    public ca:string|undefined=undefined;
    public cb:string|undefined=undefined;
    public cc:string|undefined=undefined;
    public cd:string|undefined=undefined;
    public ce:string|undefined=undefined;
    public cf:string|undefined=undefined;
    public cg:string|undefined=undefined;
    public ch:string|undefined=undefined;
    public ci:string|undefined=undefined;
    public cj:string|undefined=undefined;
    public ck:string|undefined=undefined;
    public cl:string|undefined=undefined;
    public cm:string|undefined=undefined;
    public cn:string|undefined=undefined;
    public co:string|undefined=undefined;
    public cp:string|undefined=undefined;
    public cq:string|undefined=undefined;
    public cr:string|undefined=undefined;
    public cs:string|undefined=undefined;
    public ct:string|undefined=undefined;
    public cu:string|undefined=undefined;
    public cv:string|undefined=undefined;
    public cw:string|undefined=undefined;
    public cx:string|undefined=undefined;
    public cy:string|undefined=undefined;
    public cz:string|undefined=undefined;

    public removeUnusedColumns(){
        for (let key of Object.keys(this)) {
            if(typeof (<any>this)[key] =="undefined"){
                delete (<any>this)[key];
            }
        }
    }
}